<template>
  <section class="new-filtro">
    <FiltrosDefault v-if="filtrosDefault.length > 0" :filtros="filtrosDefault" :path="dataProperties.path" />
    <BotaoAdicionarFiltro
      @renderizarFiltros="renderizarFiltros"
      :filtros="filtros"
      :campos="dataProperties.campos"
    />
    <LimparFiltro @limparFiltro="limparFiltro" />
  </section>
</template>
<script>
import BotaoAdicionarFiltro from './components/BotaoAdicionarFiltro.vue';
import LimparFiltro from './components/LimparFiltro.vue';
import FiltrosDefault from './filtros/FiltrosDefault.vue';
import { applyFiltersToListagem, PATHS_LISTAGEM_SPA } from './helpers';

const REGEX_FILTRO_RANGE = /_de$|_ate$/;
const COMPONENTE_VALOR_RANGE = 'inputs/ValorRange';

export default {
  props:{
    page:{
      type: String,
      default: () => ("{}")
    }
  },
  components: {
    BotaoAdicionarFiltro,
    LimparFiltro,
    FiltrosDefault
  },
  data() {
    return {
      dataProperties: JSON.parse(this.page)
    };
  },
  computed: {
    filtros() {
      return this.$store.state.filtros;
    },
    filtrosDefault() {
      return this.$store.state.filtros.filter(filtro => filtro.default);
    }
  },
  methods: {
    renderFiltrosDefault() {
      const filtros = this.dataProperties.campos.filter(campo => campo.default);
      filtros.forEach(filtro => {
        this.$store.commit('addFiltro', filtro);
      });
      return filtros;
    },
    salvarFiltrosNoDb() {
      const filtrosParaSalvar = this.filtros.filter(filtro => !filtro.default && !filtro.origemUrl);
      this.$filtroDb.salvarFiltros(this.dataProperties.path, filtrosParaSalvar)
        .catch(error => exibe_erro('Erro ao salvar preferencias de filtros:'));
    },
    resolverCampoDaChaveUrl(chaveUrl) {
      const campos = this.dataProperties.campos || [];

      const campoBase = campos.find(campo => campo.filtro === chaveUrl);
      if (campoBase) return campoBase;

      if (chaveUrl.endsWith('_exact')) {
        const chaveSemExact = chaveUrl.replace(/_exact$/, '');
        const campoExact = campos.find(campo => campo.filtro === chaveSemExact);
        if (campoExact) return campoExact;
      }

      const REGEX_FILTRO_PERIODO = /_ini$|_inicio$|_fim$/;
      if (REGEX_FILTRO_PERIODO.test(chaveUrl)) {
        const chaveSemPeriodo = chaveUrl.replace(REGEX_FILTRO_PERIODO, '');
        const campoPeriodo = campos.find(campo =>
          campo.filtro === chaveSemPeriodo && campo.component?.startsWith('date/')
        );
        if (campoPeriodo) return campoPeriodo;
      }

      const campoCompetencia = campos.find(campo => campo.campo_mes === chaveUrl || campo.campo_ano === chaveUrl);
      if (campoCompetencia) return campoCompetencia;

      return null;
    },
    camposReconhecidosDaURL() {
      const { arrayFiltro } = this.$capturaFiltrosDaURL();

      return [...new Set(
        arrayFiltro
          .map(chaveUrl => this.resolverCampoDaChaveUrl(chaveUrl))
          .filter(Boolean)
      )].map(campo => ({ ...campo, origemUrl: true }));
    },
    carregarFiltrosDoDb() {
      this.$filtroDb.recuperarFiltros(this.dataProperties.path)
        .then(filtrosSalvos => {
          const filtrosDefault = this.renderFiltrosDefault();
          const camposDaURL = this.camposReconhecidosDaURL();
          const filtrosCombinados = [...filtrosDefault, ...filtrosSalvos, ...camposDaURL];

          const filtrosUnicos = filtrosCombinados
            .filter((filtro, index, self) => index === self.findIndex(f => f.filtro === filtro.filtro))
            .map(filtro => {
              const filtroSalvo = filtrosSalvos.find(f => f.filtro === filtro.filtro);
              return filtroSalvo?.advancedSetting ? { ...filtro, advancedSetting: filtroSalvo.advancedSetting } : filtro;
            });

          this.renderizarFiltros(filtrosUnicos);
        })
        .catch(error => exibe_erro('Erro ao carregar preferencias de filtros:'));
    },
    limparFiltro() {
      const tiposPreservados = this.filtros.map(({ advancedSetting, ...tipo }) => ({ ...tipo }));

      this.$store.commit('limparValoresFiltros');
      this.$store.commit('setFiltros', tiposPreservados);
      this.$limparFiltrosDaURL(this.dataProperties.path);
      this.salvarFiltrosNoDb();
    },
    renderizarFiltros(filtros) {
      if (!Array.isArray(filtros)) {
        console.warn('renderizarFiltros: parâmetro deve ser um array');
        return;
      }

      const filtrosDefault = this.renderFiltrosDefault();
      const filtrosSemDefault = filtros.filter(filtro => !filtro.default);
      const filtrosCombinados = [...filtrosDefault, ...filtrosSemDefault];

      const filtrosUnicos = filtrosCombinados.filter((filtro, index, self) =>
        index === self.findIndex(f => f.filtro === filtro.filtro)
      );

      this.removeFiltrosDeselecionados(filtrosUnicos);

      filtrosUnicos.forEach(filtro => {
        this.$store.commit('addFiltro', filtro);
        if(filtro.advanced && filtro.advancedSetting) {
          const { advancedSetting, filtro: campoFiltro } = filtro;
          this.$store.commit('addAdvancedSetting', {filtro: campoFiltro, value: advancedSetting});
        }
      });
      this.$store.commit('setFiltros', filtrosUnicos);
      this.salvarFiltrosNoDb();
    },
    buscaFiltros({ campos = this.dataProperties.filtros.campos, escreverURL = true } = {}) {
      // Sufixos aceitos em filtros de periodo: _ini/_fim (DataPeriodo.vue) e _inicio/_fim
      // (DataVencimentoCobranca.vue — usado pela listagem de cobrancas, que casa com o contrato
      // do backend `data_vencimento_inicio`).
      const REGEX_FILTRO_PERIODO = /_ini$|_inicio$|_fim$/;
      const isChaveDePeriodo = (chave) => REGEX_FILTRO_PERIODO.test(chave);

      Object.keys(campos).forEach(key => {
        if (['filtro_aplicado', '_', 'page'].includes(key)) return;

        let valor = Array.isArray(campos[key]) ? campos[key].join(',') : campos[key];

        if (isChaveDePeriodo(key) && valor) {
          valor = this.converterDataParaFormatoCorreto(valor);
        }

        if (escreverURL) {
          this.$aplicaFiltroEmURL(key, valor, this.dataProperties.path);
        }

        let filtroCorrespondente = this.dataProperties.campos.find(campo => campo.filtro === key);

        if (!filtroCorrespondente && key.endsWith('_exact')) {
          const chaveBase = key.replace(/_exact$/, '');
          filtroCorrespondente = this.dataProperties.campos.find(campo => campo.filtro === chaveBase);
          if (filtroCorrespondente) {
            this.$store.commit('addAdvancedSetting', { filtro: chaveBase, value: 'exact' });
          }
        }

        if (!filtroCorrespondente && isChaveDePeriodo(key)) {
          const filtroBase = key.replace(REGEX_FILTRO_PERIODO, '');
          filtroCorrespondente = this.dataProperties.campos.find(campo =>
            campo.filtro === filtroBase && campo.component?.startsWith('date/')
          );
        }

        if (!filtroCorrespondente && REGEX_FILTRO_RANGE.test(key)) {
          const filtroBase = key.replace(REGEX_FILTRO_RANGE, '');
          filtroCorrespondente = this.dataProperties.campos.find(campo =>
            campo.filtro === filtroBase && campo.component === COMPONENTE_VALOR_RANGE
          );
        }

        if (filtroCorrespondente) {
          this.$store.commit('addFiltro', filtroCorrespondente);
          this.$store.commit('setFiltrosAplicados', {
            ...this.$store.state.filtroAplicados,
            [key]: valor
          });
        }
      });
    },
    converterDataParaFormatoCorreto(data) {
      if (typeof data !== 'string') return data;

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
        return data;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      }

      if (/^\d{2}-\d{2}-\d{4}$/.test(data)) {
        return data.replace(/-/g, '/');
      }

      return data;
    },
    removeFiltrosDeselecionados(filtrosUnicos) {
      const filtroURL = this.$capturaFiltrosDaURL();

      const filtrosValidos = new Set();
      filtrosUnicos.forEach(filtro => {
        filtrosValidos.add(filtro.filtro);

        if (filtro.component?.startsWith('date/')) {
          // Sufixo determinado pelo componente: `_inicio` apenas para DataVencimentoCobranca
          // (contrato do backend de cobrancas); `_ini` para DataPeriodo e demais telas legadas.
          if (filtro.component.endsWith('DataVencimentoCobranca')) {
            filtrosValidos.add(`${filtro.filtro}_inicio`);
          } else {
            filtrosValidos.add(`${filtro.filtro}_ini`);
          }
          filtrosValidos.add(`${filtro.filtro}_fim`);
        }

        if (filtro.component === COMPONENTE_VALOR_RANGE) {
          filtrosValidos.add(`${filtro.filtro}_de`);
          filtrosValidos.add(`${filtro.filtro}_ate`);
        }

        if (filtro.campo_mes) filtrosValidos.add(filtro.campo_mes);
        if (filtro.campo_ano) filtrosValidos.add(filtro.campo_ano);
      });

      // params de controle (paginação, formato, AJAX) que não representam filtros do usuário
      const filtrosEspeciais = ['ordem', 'page', 'filtro_aplicado', 'format', '_'];
      filtrosEspeciais.forEach(filtro => filtrosValidos.add(filtro));

      const paramsProtegidos = this.dataProperties.params_protegidos || [];
      paramsProtegidos.forEach(filtro => filtrosValidos.add(filtro));

      const filtrosDeselecionados = filtroURL.arrayFiltro.filter(filtro => !filtrosValidos.has(filtro));

      filtrosDeselecionados.forEach(filtro => {
        this.$store.commit('removeFiltro', filtro);
        this.$removeFiltroDaURL(filtro, this.dataProperties.path);
      });
    }
  },
  mounted() {
    if (!this.dataProperties?.campos) {
      console.warn('dataProperties.campos não está definido');
      return;
    }

    this.$store.commit('semearOrdemFiltrosDefault', this.dataProperties.campos);

    const { filtros } = this.$capturaFiltrosDaURL();
    const matchingCampos = this.camposReconhecidosDaURL();

    this.$store.commit('setFiltros', matchingCampos);
    this.$store.commit('setFiltrosAplicados', filtros);

    this.carregarFiltrosDoDb();

    const ehSpa = PATHS_LISTAGEM_SPA.includes(this.dataProperties.path);
    if (!ehSpa) {
      this.buscaFiltros();
    } else if (!this.$store.state.seedInicialSpaAplicado) {
      this.buscaFiltros();
      this.$store.commit('setSeedInicialSpaAplicado', true);
    } else {
      this.buscaFiltros({ campos: this.$capturaFiltrosDaURL().filtros, escreverURL: false });
    }

    const { aplicar_filtro_no_mounted, path } = this.dataProperties;
    if ( path && aplicar_filtro_no_mounted ) {
      applyFiltersToListagem(path);
    }
  }
}
</script>
